import React from "react";

const KEY = "asanight_cart";
const lineKey = (i) => i.id + JSON.stringify(i.variant || {});

export const getCart = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};
const save = (c) => {
  localStorage.setItem(KEY, JSON.stringify(c));
  window.dispatchEvent(new Event("cart-updated"));
};
export const cartCount = () => getCart().reduce((n, i) => n + i.qty, 0);
export const cartSubtotal = () => getCart().reduce((s, i) => s + i.price * i.qty, 0);
export const addToCart = (item) => {
  const c = getCart();
  const ex = c.find((x) => lineKey(x) === lineKey(item));
  if (ex) ex.qty += item.qty; else c.push(item);
  save(c);
};
export const updateQty = (idx, qty) => { const c = getCart(); if (c[idx]) { c[idx].qty = Math.max(1, qty); save(c); } };
export const removeItem = (idx) => { const c = getCart(); c.splice(idx, 1); save(c); };
export const clearCart = () => save([]);

export const useCart = () => {
  const [c, setC] = React.useState(getCart());
  React.useEffect(() => {
    const h = () => setC(getCart());
    window.addEventListener("cart-updated", h);
    return () => window.removeEventListener("cart-updated", h);
  }, []);
  return c;
};
